import React from 'react';
import EditHistoryTimeline from '../../../modules/core/public/EditHistoryTimeline';

const FIELD_I18N_KEYS = {
  name: 'catalog.history_field_name',
  subtitle: 'catalog.history_field_subtitle',
  status: 'catalog.history_field_status',
  section_title: 'catalog.history_field_section_title',
  section_subtitle: 'catalog.history_field_section_subtitle',
  layout_id: 'catalog.history_field_layout_id',
  order_type_id: 'catalog.history_field_order_type_id',
  hero_tags: 'catalog.history_field_hero_tags',
  promo_blocks: 'catalog.history_field_promo_blocks',
  composition: 'catalog.history_field_composition',
};

export default function CatalogEditHistoryTimeline({ events = [], translate }) {
  return (
    <EditHistoryTimeline
      events={events}
      translate={translate}
      fieldI18nKeys={FIELD_I18N_KEYS}
      emptyMessageKey="catalog.edit_history_empty"
      entryMessageKey="catalog.edit_history_entry"
    />
  );
}
